import { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setOriginalRoleAction,
  setRoleAction,
} from "redux/features/authSlice/AuthSlice";

const RoleContext = createContext("");
const OrignalRoleContext = createContext("");
const OriginalRoleDisptachContext = createContext((value) => {});
const RoleDispatchContext = createContext((value) => {});

const RoleProvider = ({ children }) => {
  const dispatch = useDispatch();
  const roleState = useSelector((state) => state.auth.authReducer.role);
  const originalRoleState = useSelector(
    (state) => state.auth.authReducer.originalRole
  );
  const [role, setRole] = useState("");
  const [originalRole, setOriginalRole] = useState("");

  useEffect(() => {
    setRole(roleState);
    setOriginalRole(originalRoleState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (originalRole !== "" && originalRole !== originalRoleState) {
      dispatch(setOriginalRoleAction(originalRole));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [originalRole]);

  useEffect(() => {
    if (role !== "" && roleState !== role) {
      dispatch(setRoleAction(role));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);
  return (
    <OrignalRoleContext.Provider value={originalRole}>
      <OriginalRoleDisptachContext.Provider value={setOriginalRole}>
        <RoleContext.Provider value={role}>
          <RoleDispatchContext.Provider value={setRole}>
            {children}
          </RoleDispatchContext.Provider>
        </RoleContext.Provider>
      </OriginalRoleDisptachContext.Provider>
    </OrignalRoleContext.Provider>
  );
};

export {
  RoleProvider,
  RoleContext,
  RoleDispatchContext,
  OriginalRoleDisptachContext,
  OrignalRoleContext,
};
